import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import ControllerStore from '@/store/Controller';
import VersionStore from '@/store/Version';
import RoomStore from '@/store/Room';
import WarningStore from '@/store/Warning';
import DebugStore from '@sicfe/debug/src/store';
import ProfileStore from './Profile';
Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});
export default new Vuex.Store({
    modules: {
        ProfileStore,
        ControllerStore,
        VersionStore,
        RoomStore,
        WarningStore,
        DebugStore,
    },
    plugins: [vuexLocal.plugin],
    strict: !!process.env.DEV,
});
